/**
 * Navigation Buttons Component
 * Back and Continue/Submit buttons for quote flow
 */
import { Button } from "@/components/ui/button";
import { ArrowLeft, ArrowRight, Check, Loader2, Clock } from "lucide-react";

export default function NavigationButtons({
  currentStep,
  onPrevStep,
  onNextStep,
  onSubmit,
  onMaybeLater,
  submitting,
  estimateAccepted,
}) {
  if (currentStep >= 5) return null;

  return (
    <div className="max-w-2xl mx-auto mt-8 pb-20 sm:pb-8 flex flex-col sm:flex-row justify-between gap-4">
      {currentStep > 1 ? (
        <Button
          variant="outline"
          onClick={onPrevStep}
          className="btn-secondary flex-1 sm:flex-none order-2 sm:order-1"
          data-testid="prev-step-btn"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back
        </Button>
      ) : (
        <div className="hidden sm:block order-1" />
      )}

      {currentStep < 4 ? (
        <Button 
          onClick={onNextStep} 
          className={`btn-primary ${currentStep === 1 ? 'w-full sm:w-auto' : 'flex-1 sm:flex-none'} order-1 sm:order-2`} 
          data-testid="next-step-btn"
        >
          Continue
          <ArrowRight className="w-4 h-4 ml-2" />
        </Button>
      ) : (
        <div className="flex flex-col sm:flex-row gap-3 flex-1 sm:flex-none order-1 sm:order-2">
          {/* Maybe Later Button */}
          <Button
            variant="outline"
            onClick={onMaybeLater}
            disabled={submitting}
            className="border-slate-300 text-slate-600 hover:bg-slate-100"
            data-testid="maybe-later-btn"
          >
            <Clock className="w-4 h-4 mr-2" />
            Maybe Later
          </Button>
          
          {/* Submit Quote Button */}
          <Button
            onClick={onSubmit}
            disabled={submitting || !estimateAccepted}
            className="btn-primary"
            data-testid="submit-quote-btn"
          >
            {submitting ? (
              <>
                <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                Submitting...
              </>
            ) : !estimateAccepted ? (
              <>Accept Estimate to Continue</>
            ) : (
              <>
                Submit Quote
                <Check className="w-4 h-4 ml-2" />
              </>
            )}
          </Button>
        </div>
      )}
    </div>
  );
}
